import { render, staticRenderFns } from "./people_level.vue?vue&type=template&id=21a0f031&scoped=true"
import script from "./people_level.vue?vue&type=script&lang=js"
export * from "./people_level.vue?vue&type=script&lang=js"
import style0 from "./people_level.vue?vue&type=style&index=0&id=21a0f031&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a0f031",
  null
  
)

export default component.exports